import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const getInitialStravaAuthCode = (location: ReturnType<typeof useLocation>) => {
  const searchParams = new URLSearchParams(location.search);
  return searchParams.has("code") ? (searchParams.get("code") as string) : null;
};

const useStravaAuthCode = () => {
  const location = useLocation();
  const [stravaAuthCode] = useState<string | null>(() => getInitialStravaAuthCode(location));

  useEffect(() => {
    if (stravaAuthCode !== null) {
      window.history.replaceState(null, "", window.location.pathname);
    }
  }, [stravaAuthCode]);

  return stravaAuthCode;
};

export default useStravaAuthCode;
